module.exports = require('./pca');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-pca/src/index.js
 ** module id = 86
 ** module chunks = 0
 **/